import script from "./ApprovedVersion.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApprovedVersion.vue?vue&type=script&lang=ts&setup=true"

import "./ApprovedVersion.vue?vue&type=style&index=0&id=92e70158&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92e70158"]])

export default __exports__